import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import { TenantContext } from '../../tenant/TenantContext';
import { SecurityContext } from '../../security/SecurityContext';

function Footer (props) {
  const { businessConfig } = useContext(TenantContext);
  const secCtx = useContext(SecurityContext);
  
    return (
      <footer className="footer px-0 px-lg-3">
        <Container fluid>
          <nav>
            <ul className="footer-menu">
              <li>
                <a href={businessConfig.url}>
                {!secCtx.authState && "Return to "}{businessConfig.name}
                </a>
              </li>
            </ul>
            <p className="copyright text-center">
              © {new Date().getFullYear()}{" "}
              copyright&nbsp;<a href="mailto:info@benevare.com?subject=Info Request">&nbsp;Benevare Inc.</a>
            </p>
          </nav>
        </Container>
      </footer>
    );
}

export default Footer;
